import React, { useEffect, useState } from "react";
import "./Movie.css";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import Axios from "../../utils/Axios";
import SummaryAPI from "../../common/SummaryAPI";
import AxiosToastError from "../../utils/AxiosToastError";
import Chatbox from "../../components/Chatbox";


const MovieDetail = () => {
  const [movieInfo, setMovieInfo] = useState();
  const { id } = useParams();
  const user = useSelector((state) => state.user);
  const [review, setReview] = useState("");
  const [rating, setRating] = useState(0);
  const [reviews, setReviews] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    fetchMovie();
    fetchReviews();
    window.scrollTo(0, 0);
  }, []);

  const API_KEY = process.env.REACT_APP_TMDB_API_KEY;
  const fetchMovie = () => {
    fetch(
      `https://api.themoviedb.org/3/movie/${id}?api_key=${API_KEY}&language=en-US`
    )
      .then((res) => res.json())
      .then((data) => setMovieInfo(data));
  };

  const fetchReviews = async () => {
    try {
      const response = await Axios({
        ...SummaryAPI.getReviews,
        params: { movieID: id },
      });
      setReviews(response.data.data);
    } catch (error) {
      AxiosToastError(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await Axios({
        ...SummaryAPI.makeReview,
        data: {
          movieID: id,
          movieTitle: movieInfo.original_title,
          rating: rating,
          review: review,
        },
      });

      if (response.data.success) {
        toast.success(response.data.message);
        setReview("");
        setRating(0);
        navigate("/");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      AxiosToastError(error);
    }
  };

  const handleWatchlistAdd = async () => {
    try {
      const movieData = {
        movieId: movieInfo.id,
        title: movieInfo.title,
        posterPath: movieInfo.poster_path,
      };

      await Axios.post(`/api/user/${user._id}/add`, { movie: movieData });
      toast.success("Added to watchlist!");
    } catch (err) {
      console.error(err);
      toast.error("Failed to add to watchlist");
    }
  };

  async function handleFollow(targetUserId) {
  try {
    const apiDetails = SummaryAPI.sendFollowRequest(targetUserId);
    const response = await Axios({
      url: apiDetails.url,
      method: apiDetails.method,
    });
    console.log('Follow request sent:', response.data);
  } catch (error) {
    console.error('Error sending follow request:', error);
  }
}

  return (
    <div className="movieDetail">
      {/* <div className="movieBanner">
        <img
          className="movieBackdrop"
          src={`https://image.tmdb.org/t/p/original${
            movieInfo ? movieInfo.backdrop_path : ""
          }`}
          alt="Backdrop"
        />
      </div> */}
      <div className="movieContent">
        <div className="moviePosterSection">
          <div className="moviePosterBox">
            <img
              className="moviePoster"
              src={`https://image.tmdb.org/t/p/original${
                movieInfo ? movieInfo.poster_path : ""
              }`}
              alt="Poster"
            />
          </div>
        </div>
        <div className="movieInfoSection">
          <div className="movieInfoTop">
            <div className="movieTitle">
              {movieInfo ? movieInfo.original_title : ""}
            </div>
            <div className="movieTagline">
              {movieInfo ? movieInfo.tagline : ""}
            </div>
            <div className="movieRuntime">
              {movieInfo ? `Runtime: ${movieInfo.runtime} mins` : ""}
            </div>
            <div className="movieReleaseDate">
              {movieInfo ? `Release date: ${movieInfo.release_date}` : ""}
            </div>
            <div className="movieGenres">
              {movieInfo && movieInfo.genres
                ? movieInfo.genres.map((genre) => (
                    <span className="movieGenre" key={genre.id}>
                      {genre.name}
                    </span>
                  ))
                : ""}
            </div>
          </div>
          <div className="movieInfoBottom">
            <div className="movieSynopsisHeading">Synopsis</div>
            <div className="movieSynopsis">
              {movieInfo ? movieInfo.overview : ""}
            </div>
          </div>

          {user && user._id && (
            <button onClick={handleWatchlistAdd}>Add to Watchlist</button>
          )}

          <div className="leaveReview">
            <div className="leaveReviewHeading">Leave a Review!</div>
            {user && user._id ? (
              <form className="reviewForm" onSubmit={handleSubmit}>
                <textarea
                  value={review}
                  onChange={(e) => setReview(e.target.value)}
                  className="reviewTextArea"
                  placeholder="Share your thoughts!"
                  required
                />
                <input
                  type="number"
                  value={rating}
                  onChange={(e) => setRating(e.target.value)}
                  min={1}
                  max={5}
                  placeholder="Rating (1-5)"
                  required
                />
                <button type="submit" className="reviewSubmit">
                  Submit Review!
                </button>
              </form>
            ) : (
              <div className="leaveReviewLoginReroute">
                <p>
                  <Link to="/login"> Login </Link> to leave a review!
                </p>
              </div>
            )}
          </div>
          <div className="Chatroom">
                        <div className="Chatroom">Find friends to watch with!</div>
                        {user && user._id ? (
                        <p>
                            Chatroom:
                            <Chatbox room={id} />
                        </p>
                        ) : (
                            <div className="ChatroomLoginReroute">
                                <p>
                                    <Link to="/login"> Login </Link> to chat with others!
                                </p>
                            </div>
                        )}
                    </div>
          <div className="movieReviews">
            <div className="movieReviewsHeading">Reviews</div>
            {reviews.map((review) => (
              <div key={review._id} className="reviewCard">
                <div className="reviewUser">
                  {review.user && review.user.avatar && (
                    <img
                      src={review.user.avatar}
                      alt="User"
                      className="reviewUserAvatar"
                    />
                  )}
                  <span>{review.user?.name}</span>
                  {user &&
                    user._id !== review.user?._id && (
                      <button
                        className="follow-button"
                        onClick={() => handleFollow(review.user._id)}
                      >
                        Follow
                      </button>
                    )}
                </div>
                <div className="reviewRating">
                  <span>Rating: {review.rating}</span>
                </div>
                <div className="reviewText">
                  <span>{review.review}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MovieDetail;
